import styled from 'styled-components'
import Modal from 'components/Modal'
import { Button, Text, Separator } from '@sketch/components'
import { Breadcrumbs } from 'modules/shares/components/Breadcrumbs'
import { ReactComponent as ExclamationMarkIcon } from '@sketch/icons/exclamation-mark-16-svg'

// Project Sharing Modal is wider than
// regular modals
export const StyledModal = styled(Modal)`
  max-width: 705px;
`

export const StyledSeparator = styled(Separator)`
  margin-top: 24px;
  margin-bottom: 4px;
`

export const StyledBreadcrumbs = styled(Breadcrumbs)`
  margin-top: 4px;
`

export const InviteButton = styled(Button).attrs({
  variant: 'primary',
  size: '40',
})`
  width: 92px;
  margin-left: 16px;
  align-self: end;
`

export const MemberInviteSection = styled.section`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 16px;
`
export const PermissionText = styled.span<{ noAccess?: boolean }>`
  padding: 0 12px;
  font-size: ${({ theme }) => theme.fontSizes.D};
  color: ${({ theme, noAccess }) =>
    noAccess
      ? theme.colors.state.negative.A
      : theme.colors.foreground.secondary.D};
`

export const WorkspaceRowWarningText = styled(Text.Span).attrs({
  textStyle: 'copy.quaternary.standard.C',
})`
  line-height: 1;
  display: flex;
  align-items: center;
  margin-top: 2px; /* stylelint-disable-line scales/space */
`

export const ExclamationMark = styled(ExclamationMarkIcon)`
  color: ${({ theme }) => theme.colors.foreground.secondary.D};
  opacity: 1;
  width: 16px;
  height: 16px;
  margin-right: 4px;
`
